import { bindActionCreators, compose } from "redux";
import { connect } from "react-redux";
import { withRouter } from 'react-router';
import dataFetcher from "../../../parts/chore/dataFetcher";
import GoalsPage from './GoalsPage';
import { createIncentive, updateIncentive, deleteIncentive, fetchIncentives } from '../../../campaign/campaignActions.js'

const mapStateToProps = state => ({
  campaign: state.campaign.campaign,
  incentives: state.campaign.incentives,
  locale: state.session.language,
  participants: state.participant.participants.results,
  pagination: state.participant.participants.pagination,
  platformId: state.platform.platform.id
});

const mapDispatchToProps = dispatch => bindActionCreators({
  createIncentive, updateIncentive, deleteIncentive, fetchIncentives
 }, dispatch);

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withRouter,
  dataFetcher
)(GoalsPage);